// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1788930442494
      var cssReload = require("../node_modules/.pnpm/@umijs+bundler-webpack@4.3.35_@types+webpack@5.28.5_type-fest@1.4.0_typescript@5.9.3_webpack@5.102.0/node_modules/@umijs/bundler-webpack/compiled/mini-css-extract-plugin/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","emit":true,"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  